import { CSSProperties, useCallback, useState } from "react"
import { SeamlessInput } from "../canvas-ui/SeamlessInput"

type Props = {
  value: string
  onChange: (newName: string) => void
}

// export function EditableDrawingName({ value, onNameChange }: Props) {
//   // TODO(alvaro): Pre-select text when editing

//   const [editing, setEditing] = useState(false)

//   if (!editing) {
//     return (
//       <div onClick={() => setEditing(true)}>{value}</div>
//     )
//   }
//   return (
//     <IonInput
//       value={value}
//       onIonInput={(e) => onNameChange(e.detail.value!)}
//       //onIonChange={(e) => handleChangeDrawingName(e.detail.value!)}
//       // onIonBlur={e => handleChangeDrawingName(editableTitle)}
//       hidden
//       placeholder="Enter drawing name"
//       //clearInput
//       style={{
//         border: '1px solid #ccc',
//         borderRadius: '4px',
//         padding: '8px',
//         marginTop: '8px',
//         display: 'block',
//       }}
//     />
//   )
// }

export function EditableDrawingName({ value, onChange }: Props) {
  const [editing, setEditing] = useState(false)

  const handleInputBlur = useCallback(function handleInputBlur(value: string) {
    console.log("handleInputBlur", value)
    setEditing(false)
    onChange(value)
  }, [])

  if (!editing) {
    return <div onClick={() => setEditing(true)}>{value}</div>
  }
  return (
    <SeamlessInput
      style={nameStyle}
      value={value}
      onBlur={handleInputBlur}
      onInputChange={() => {}}
    />
  )
}

const nameStyle: CSSProperties = {
  padding: "2px 4px",
  borderRadius: 3,
  margin: "0 -4px",
}
